export class FlexSearchRequest {
    cosyToken : string;
    entityID: string;
    searchText: string;
    whereClause: string;
    whatClause: string;
    tableName: string;
    mode: string;
    system: string;
    attributes: string[];
    filters: Filter[];
}

export class Filter {
    type : string;
    enabled: boolean;
    typeFilter : string;
    items: FilterItem[];
}

export class FilterItem {
    ID : string;
    displayName: string;
}
